import uuidv4 from 'uuid/v4';
import Vue from 'vue';

export default {
  data() {
    return {
      name: null,
      uuid: null,
    };
  },
  created() {
    this.name = this.getName();
    this.uuid = this.getUuid();
  },
  methods: {
    getUuid() {
      let objectUuid = this.uuid;
      if (objectUuid === null) {
        if (this.element) {
          objectUuid = this.element.uuid;
        }
        if (this.pageComponent) {
          objectUuid = this.pageComponent.uuid;
        }
      }
      return objectUuid;
    },
    getName() {
      let myName = this.name;
      if (myName === null) {
        if (this.element) {
          myName = this.element.name;
        } else if (this.pageComponent) {
          myName = this.pageComponent.name;
        }
      }
      return myName;
    },
    getProperties() {
      let myProperties = this.properties;
      if (myProperties === null) {
        if (this.element) {
          myProperties = this.element.properties;
        } else if (this.pageComponent) {
          myProperties = this.pageComponent.properties;
        }
      }
      return myProperties;
    },
    getObjectType() {
      let myType = this.type;
      if (myType === null) {
        if (this.element) {
          myType = this.element.properties.element_type;
        } else if (this.pageComponent) {
          myType = this.pageComponent.properties.element_type;
        }
      }
      return myType;
    },
    getRootBoundBox(uuid = this.uuid) {
      let rootContainers = [];
      if (uuid) {
        const target = this.searchInRootForElementOrComponent(uuid);
        if (target) {
          rootContainers = this.$root.$el.querySelectorAll(`[data-root='true'][session-uuid='${target.sessionUuid}']`);
        }
      }
      return rootContainers;
    },
    temporarilyPauseAllVideosInTree(uuid) {
      if (uuid) {
        const target = this.searchInRootForElementOrComponent(uuid);
        if (target) {
          const elements = target.$el.querySelectorAll("[data-type='video']:not([autoplay='autoplay'])");
          for (let i = 0; i < elements.length; i += 1) {
            const element = elements[i];
            const videoElementUuid = element.getAttribute('id');
            if (videoElementUuid) {
              this.pauseVideo(videoElementUuid);
            }
          }
        }
      }
    },
    muteAllVideos() {
      const elements = this.$root.$el.querySelectorAll("[data-type='video']");
      for (let i = 0; i < elements.length; i += 1) {
        const element = elements[i];
        const videoElementUuid = element.getAttribute('id');
        if (videoElementUuid) {
          this.muteVideo(videoElementUuid);
        }
      }
    },
    unmuteAllVideos() {
      const elements = this.$root.$el.querySelectorAll("[data-type='video']");
      for (let i = 0; i < elements.length; i += 1) {
        const element = elements[i];
        const videoElementUuid = element.getAttribute('id');
        if (videoElementUuid) {
          this.unmuteVideo(videoElementUuid);
        }
      }
    },
    pauseVideo(targetUuid) {
      const target = this.searchInRootForElementOrComponent(targetUuid);
      if (target) {
        const lock = Vue.prototype.$videoLock;
        if (lock && targetUuid === lock.uuid) {
          this.$eventHub.$emit('clear_video_lock');
        }
        target.$el.pause();
      }
    },
    muteVideo(uuid) {
      if (uuid) {
        const video = document.getElementById(uuid);
        video.muted = true;
      }
    },
    unmuteVideo(uuid) {
      if (uuid) {
        let isMuted = false;
        const videoObject = this.searchInRootForElementOrComponent(uuid);
        if (videoObject) {
          isMuted = videoObject.properties.muted;
        }
        const video = document.getElementById(uuid);
        video.muted = isMuted;
      }
    },
    /**
     * Attempts to search in root to find the issue
     * I propose we rename this to 'rummageInRoot' ~ Araymer
     */
    searchInRootForElementOrComponent(uuid, parent = this.$root) {
      let value = null;
      if (parent.$refs[uuid]) return parent;
      // iterate through to find the child
      for (let i = 0; i < parent.$children.length; i += 1) {
        const child = parent.$children[i];
        // check
        if (child.$refs[uuid]) {
          value = child;
          break;
        }
        if (child.$children.length > 0) value = this.searchInRootForElementOrComponent(uuid, child);
        if (value) break;
      }
      return value;
    },
    fireEventRecorder(event, userAction = false, sessionUuid = this.sessionUuid) {
      const metaData = {
        version: this.eventVersion ? this.eventVersion : '1.0.1',
        helper: 'SharedMixinMethods',
        function: 'fireEventRecorder',
        vueEnvironment: process.env.VUE_APP_ENV,
        nodeEnvironment: process.env.NODE_ENV,
        params: {
          event,
          userAction,
          sessionUuid,
        },
      };
      const data = {
        ...{
          name: this.name,
          uuid: this.getUuid(),
          metaData,
          environment: process.env.VUE_APP_ENV,
        },
        ...event,
      };
      const eventData = {
        // data: event,
        // eslint-disable-next-line
        data: data,
        sessionUuid,
        userAction,
      };
      this.log(`fireEventRecorder: ${event.type}`, eventData);
      this.$eventHub.$emit('event_recorder', eventData);
    },
    blurThisClickHandler(e, modal, closestElement) {
      // force modal closure by passing in associated modal uuid to hideModal
      this.hideModal({ target_uuid: modal.$el.getAttribute('id') });
      // remove blur-this click event now that that modal is closed.
      closestElement.removeEventListener('click', modal.ev, true);
      // stop all modal videos.
      const videos = document.getElementsByClassName('modalVideo');
      for (let i = 0; i < videos.length; i += 1) {
        videos[i].load();
      }
    },
    hideModal(event) {
      // find the modal
      const modal = this.searchInRootForElementOrComponent(event.target_uuid);
      if (modal) {
        // remove active class
        if (modal.targetContainer) modal.targetContainer.classList.remove('active');
        // setup animation for modal
        modal.$el.classList.remove('run-animation');
        modal.$el.classList.add('run-animation-close');
        // check if blur-this click event is present, if so clean it up.
        if (modal.ev && modal.closest) {
          modal.closest.removeEventListener('click', modal.ev, true);
        }
        // setup a timeout so we know what to do later
        setTimeout(() => {
          modal.properties.hidden = true;
          // Resets scrollable areas to top
          const elements = modal.$el.querySelectorAll('[data-type]');
          const elementsLength = elements.length;
          for (let i = 0; i < elementsLength; i += 1) {
            if (elements[i].getAttribute('data-type') === 'scrollable_area') {
              elements[i].scrollTo(0, 0);
            }
          }
          this.unmuteAllVideos();
        }, 200);
      }
    },
    /**
     * Open a "MODAL", which normally isn't a component of type modal but something else entirely
     * @param event
     */
    showModal(event) {
      const btn = document.getElementById(event.source);
      const closestElement = btn ? btn.closest('.blur-this') : null;
      const modal = this.searchInRootForElementOrComponent(event.target_uuid);
      if (modal) {
        if (closestElement) {
          closestElement.classList.add('active');
          modal.targetContainer = closestElement;
          if (modal.ev && modal.closest) {
            modal.closest.removeEventListener('click', modal.ev, true);
          }
          const scope = this;
          modal.ev = (evt) => {
            // this mess is to get around lint's no-param-reassign rule
            // in this case reassigning a paramater is valid as I am
            // cancelling mouse event bubbling in the capture phase.
            const e = evt;
            e.cancelBubble = true;
            scope.blurThisClickHandler(event, modal, closestElement);
          };
          modal.closest = closestElement;
          closestElement.addEventListener('click', modal.ev, true);
        }
        modal.$el.classList.remove('run-animation-close');
        modal.$el.classList.add('run-animation');
        modal.properties.hidden = false;
        const rootBoundingBoxes = this.getRootBoundBox(modal.uuid);
        console.log(rootBoundingBoxes);
        for (let i = 0; i < rootBoundingBoxes.length; i += 1) {
          const rootBoundingBox = rootBoundingBoxes[i];
          if (rootBoundingBox) {
            const bbUuid = rootBoundingBox.getAttribute('id');
            this.temporarilyPauseAllVideosInTree(bbUuid);
            this.muteAllVideos();
          }
        }
      }
    },
    /**
     * Resets the element to it's default props and classes
     */
    resetToDefault(target) {
      if (target) {
        // eslint-disable-next-line no-param-reassign
        if (target.properties) target.properties = Object.assign({}, target.originalProperties);
        // if card-flip remove active class OR if blur-this remove active class
        if (target.$el.classList.contains('card-flip') || target.$el.classList.contains('blur-this')) {
          target.$el.classList.remove('active');
        }
        // if video, then restart
        try {
          if (target.$el.getAttribute('data-type') === 'video') target.$el.load();
        } catch (err) {
          console.warn('resetToDefault error', err);
        }
        // call callback if exists
        if (typeof target.resetCallback === 'function') target.resetCallback();
      }
    },
    /**
     * Resets the tree back to its default. We just call default again but iterate through
     * @param parentTarget
     */
    resetTreeToDefault(parentTarget) {
      // reset parent
      this.resetToDefault(parentTarget);
      // recursively iterate back and call again
      if (parentTarget) {
        parentTarget.$children.forEach((child) => {
          // reset your child
          this.resetToDefault(child);
          // call it again
          this.resetTreeToDefault(child);
        });
      }
    },
    createTemporaryOverlay(uuid, text = '', duration = 5000, colour = 'rgba(0,0,0,0.5)') {
      if (uuid) {
        const parentObject = this.searchInRootForElementOrComponent(uuid);
        if (parentObject) {
          const parentDiv = document.getElementById(uuid);
          const divUuid = uuidv4();
          const div = document.createElement('div');
          div.style.position = 'absolute';
          div.style.width = `${parentObject.properties.width}px`;
          div.style.height = `${parentObject.properties.height}px`;
          div.style.left = `${parentObject.properties.x}px`;
          div.style.top = `${parentObject.properties.y}px`;
          div.style.backgroundColor = colour;
          div.style.zIndex = 300000;
          div.style.display = 'flex';
          div.style.justifyContent = 'center';
          div.style.alignItems = 'center';
          div.style.alignContent = 'center';
          div.style.cssFloat = 'left';
          div.id = divUuid;
          if (text) {
            div.innerHTML = `<span style="color: #ffffff; font-size: 1.5em;">${text}</span>`;
          }
          parentDiv.parentNode.appendChild(div);
          setTimeout(() => {
            div.remove();
          }, duration);
        }
      }
    },
  },
};
